enum SeasonalStatus {
    NotAvailable = 'not-available',
    Available = 'available',
    Best = 'best'
}

export default SeasonalStatus